'use client'

import dynamic from 'next/dynamic'
import Link from 'next/link'
import { Grid } from '@mui/material'
import { useWatch } from 'react-hook-form'

// Types
import type { FormProps } from '@/types/components/organisms/forms'

// Components
const TextFieldMolecule = dynamic(() => import('@/components/molecules/field/text'))
const PrimaryButtonAtom = dynamic(() => import('@/components/atoms/button/primary'))
const SecondaryButtonAtom = dynamic(() => import('@/components/atoms/button/secondary'))
const TitleTypographyAtom = dynamic(() => import('@/components/atoms/typography/title'))
const ParagraphTypographyAtom = dynamic(() => import('@/components/atoms/typography/paragraph'))

const UsernameFormOrganism = (props: FormProps) => {
	// Props
	const { lng, locale, control, formState, loading, onConfirm } = props

	// Variables
	const usernameValue: string = useWatch({ control, name: 'username' })
	const passwordValue: string = useWatch({ control, name: 'password' })
	const disabled = !usernameValue || !passwordValue
	const errors = formState?.errors ?? {}

	return (
		<Grid
			component="form"
			container
			spacing={2}
			sx={{
				justifyContent: 'center',
				alignItems: 'center',
				flexDirection: 'column',
				width: 1,
				minHeight: 1,
				borderRadius: 3
			}}
		>
			<Grid size={12}>
				<TitleTypographyAtom text={locale.common.title.loginWithUsername} textAlign="center" />
				<ParagraphTypographyAtom text={locale.common.description.inputYourCredentials} textAlign="center" />
			</Grid>

			<Grid size={12}>
				<TextFieldMolecule lng={lng} control={control} name="username" type="alias" label={locale.form.label.username} required />
			</Grid>

			<Grid size={12}>
				<TextFieldMolecule lng={lng} control={control} name="password" type="password" label={locale.form.label.password} required />
			</Grid>

			<Grid size={12} sx={{ '& .MuiButtonBase-root': { width: 1 } }}>
				<SecondaryButtonAtom
					text={locale.form.button.login}
					type="submit"
					size="large"
					loading={loading}
					disabled={loading || disabled || Object.keys(errors).length > 0}
					onClick={onConfirm}
				/>
			</Grid>

			<Grid size={12} sx={{ '& .MuiButtonBase-root': { width: 1 } }}>
				<Link href={`/${lng}/login`}>
					<PrimaryButtonAtom text={locale.form.link.loginWithMobile} type="submit" size="large" />
				</Link>
			</Grid>
		</Grid>
	)
}

export default UsernameFormOrganism
